import React from "react";
import success from "../../assets/success-circle.png";
// import failed from "../../assets/failed-circle.png";

interface TransactionRecordProps {
  status: string;
  title: string;
  paymentMethod: string;
  date: string;
  amount: string;
}

export default function TransactionRecord({
  status,
  title,
  paymentMethod,
  date,
  amount,
}: TransactionRecordProps) {
  return (
    <div className="flex items-center justify-evenly w-full py-5 px-2">
      <div className="lg:flex items-center justify-evenly w-1/3 lg:w-2/5">
        <h2 className="transaction-text">{title}</h2>
        <h2 className="transaction-text">{paymentMethod}</h2>
      </div>
      <div className="lg:flex items-center justify-evenly w-1/3 lg:w-2/5">
        <h2 className="transaction-text">{date}</h2>
        <div className="flex items-center space-x-2">
          {status === "success" && (
            <img src={success} alt="" className="w-3 h-3" />
          )}
          {/* <img
            src={status === "success" ? success : failed}
            alt=""
            className="w-3 h-3"
          /> */}
          <div className="flex items-center space-x-2">
            <h2
              className={`font-medium text-lg ${
                status === "success" ? "text-success" : "text-error"
              }  capitalize`}
            >
              {status}
            </h2>
            {status !== "success" && (
              <div className="max-lg:hidden cursor-pointer bg-border/20 py-1 px-2 rounded-lg">
                <h1 className="text-sm">Retry</h1>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="lg:flex items-center justify-center w-1/3 lg:w-1/5">
        <h2 className="text-themeText font-semibold text-lg">-NGN {amount}</h2>
        {status !== "success" && (
          <div className="lg:hidden w-fit cursor-pointer bg-border/20 py-1 px-2 rounded-lg">
            <h1 className="text-sm">Retry</h1>
          </div>
        )}
      </div>
    </div>
  );
}
